(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestResultController', ObjectTestResultController);

    ObjectTestResultController.$inject = ['$scope', '$state', 'ObjectTestResult', 'TestSchedule', 'ParseLinks', 'AlertService', 'id', 'TabObjects', '$timeout', 'TestSettingTag', 'scheduleId', 'fromManualTests'];

    function ObjectTestResultController($scope, $state, ObjectTestResult, TestSchedule, ParseLinks, AlertService, id, TabObjects, $timeout, TestSettingTag, scheduleId, fromManualTests) {
        var vm = this;
        vm.tabObjects = [];
        vm.objectTestResults = [];
        vm.charToSearch = "";
        vm.page = 0;

        TestSettingTag.byDomain({size: 1000}, function (result) {
            vm.testsTag = result;
            vm.filterTag = {};
            vm.filterTag.id = -1;
            vm.filterTag.testTag = "All";
            vm.testsTag.unshift(vm.filterTag);
        })

        if (id !== null && id !== undefined) {
            vm.objectTestResults = [];
            loadTest();
        }

        vm.reloadTest = function () {
            vm.objectTestResults = [];
            loadTest();
        }

        function checkAndOrderByManualTests() {
            vm.objectTestResults.forEach(function (test) {
                test.check = test.objectTestSetting.manual;
                vm.objectTestResults.sort((a, b) => b.check - a.check);
            });
        }

        function defaultCheckAndOrder() {
            vm.objectTestResults.forEach(function (test) {
                test.check = false;
            });
            vm.objectTestResults.sort((a, b) => new Date(b.lastExecution) - new Date(a.lastExecution));
        }

        function loadTest() {
            vm.hasNotResults = false;
            TabObjects.get({id: id}).$promise.then(function (data) {
                vm.obj = data;
                vm.areChk = false;
                ObjectTestResult.retrieveObjectTest({object: id, testTagId: vm.filterTag === undefined ? -1 : vm.filterTag.id})
                    .$promise.then(function (tests) {
                        vm.objectTestResults = tests;
                        if(scheduleId != null) {
                            ObjectTestResult.bySchedule({id: scheduleId}).$promise.then(function (testsBySchedule) {
                                checkSelectedTests(testsBySchedule);
                            });
                        } else if(fromManualTests === true) {
                            checkAndOrderByManualTests();
                        } else {
                            defaultCheckAndOrder();
                        }

                        vm.hasNotResults = !tests.length > 0;
                    });
            });
        }

        function checkSelectedTests(scheduleTests) {
            vm.objectTestResults.forEach(function (test) {
                test.check = false;
                scheduleTests.forEach(function (scheduleTest) {
                    if (test.id === scheduleTest.id) {
                        test.check = true;
                        test.isUpdatedByOther = test.lastExecutionByTestScheduleId !== scheduleId;
                    }
                });
            });
            vm.objectTestResults.sort((a,b) => b.check - a.check);
        }

        vm.currentState = "object-test-result";

        vm.loadAll = function () {
            TabObjects.query({
                page: vm.page,
                size: 20,
                query: vm.charToSearch
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjects.push(data[i]);
                }
                vm.objNotSelected = id === null || id === undefined;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.reset = function () {
            vm.page = 0;
            vm.tabActions = [];
            vm.loadAll();
        };

        vm.loadPage = function (page) {
            if (page < vm.links['last'] || page === vm.links['next']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.search = function (searchText) {
            vm.charToSearch = searchText;
            vm.page = 0;
            vm.tabObjects = [];
            vm.loadAll();
        };

        vm.selectObject = function (obj) {
            vm.hasNotResults = false;
            $state.transitionTo($state.$current, {
                id: obj.id
            }, {notify: true, location: "replace"});
        };

        vm.checkAll = function (b) {
            vm.objectTestResults.forEach(function (test) {
                test.check = vm.areChk;
            });
        }

        vm.areAllChecked = function () {
            var allChecked = true;
            var notChecked = true;
            vm.objectTestResults.forEach(function (test) {
                allChecked = test.check && allChecked;
                notChecked = !test.check && notChecked;
            });
            if(allChecked) vm.areChk = allChecked;
            else if(notChecked) vm.areChk = !notChecked;
        }

        vm.clickedAtLeastOneTest = function () {
            var isChecked = false;
            vm.objectTestResults.forEach(function (test) {
                isChecked = isChecked || test.check
            });
            return isChecked;
        }

        function getCheckedTestListId() {
            var checkedTestResultsId = "";
            vm.objectTestResults.forEach(function (test) {
                if(test.check)
                    checkedTestResultsId = checkedTestResultsId + (checkedTestResultsId === "" ? "" : ",") + test.id;
            });
            return checkedTestResultsId;
        }

        vm.downloadPdf = function () {
            var a = document.createElement("a");
            document.body.appendChild(a);
            var tagId = vm.filterTag === undefined ? -1 : vm.filterTag.id;
            a.href = "api/object-test-result-pdf/" + id + "?test=" + getCheckedTestListId() +"&timeZone=" + encodeURI(Intl.DateTimeFormat().resolvedOptions().timeZone);
            a.setAttribute("target", "_blank");
            a.download = name[name.length - 1];
            a.click();
        };
    }
})();
